import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Home from '../pages/Home';
import AboutUs from '../pages/AboutUs';
import WhatWeDo from '../pages/WhatWeDo';
import Portfolio from '../pages/Portfolio';

const Routes: React.FC = () => (
  <Switch>
    <Route path="/" exact component={Home} />
    <Route path="/sobre" exact component={AboutUs} />
    <Route path="/nos" exact component={WhatWeDo} />
    <Route path="/portfolio" exact component={Portfolio} />
  </Switch>
);

export default Routes;
